import React from 'react';

import { Button, Grid2 as Grid } from '@mui/material';

const OptimizedRouteButtons = ({
  icon: Icon,
  multipleButtonsLabel,
  routes,
  serviceLabel,
}) => {
  return (
    <Grid container spacing={2} justifyContent="center" width="100%" my={3}>
      {routes.map((routeLink, index) => (
        <Grid key={`google-link-${index}`} size={{ xs: 12, sm: 'auto' }}>
          <Button
            variant="contained"
            component="a"
            href={routeLink}
            target="_blank"
            rel="noreferrer"
            startIcon={<Icon />}
            fullWidth
            sx={{ textTransform: 'none' }}
          >
            Ver en {serviceLabel}{' '}
            {routes.length > 1 && `- ${multipleButtonsLabel} ${index + 1}`}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default OptimizedRouteButtons;
